import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Layouts } from 'app-components';
import { useAppDispatch } from '@hooks/index';
import IssuerSidebar from '@components/common/nav/IssuerSidebar';
import NavBarContainer from '@containers/common/NavBarContainer';
import FeaturePlanMainContent from './FeaturePlanMainContent';
import { getFeaturePlanList, setSidebarParams } from '@actions/featurePlan/featurePlanActionCreators';

const LayoutContainer = styled.div`
  .grid-row {
    padding: 0;
  }

  .grid-col-12 {
    padding: 0;
  }

  #gi-sidebar {
    padding-left: 0;
    padding-right: 24px;
  }
`;

const getSessionValue = (key: string, defaultValue: string | boolean) => {
    const value = sessionStorage.getItem(key);
    return value !== null ? (typeof defaultValue === 'boolean' ? value === 'true' : value) : defaultValue;
};

const IssuerFeaturePlanContainer = () => {
    const dispatch = useAppDispatch();
    const { id } = useParams();
    const encIssuerId = id || '';
    const hiosIssuerId = getSessionValue('hiosIssuerId', '');
    const ssioEnabled = getSessionValue('ssioEnabled', false);
    const issuerName = getSessionValue('issuerName', '');
    const enableFeaturedPlans = getSessionValue('enableFeaturedPlans', false);
    const turquoisePlansEnabled = getSessionValue('turquoisePlansEnabled', false);
    const logoSrc = `/hix/admin/issuer/company/profile/logo/hid/${hiosIssuerId}`;
    
    useEffect(() => {
        dispatch(getFeaturePlanList(encIssuerId));
        dispatch(
            setSidebarParams({
                encIssuerId,
                issuerName,
                hiosIssuerId,
                ssioEnabled,
                enableFeaturedPlans,
                turquoisePlansEnabled,
            }),
        );
    }, []);

    return(
        <LayoutContainer>
            <Layouts id="sidenav-layout">
                <Layouts.Row hasGap>
                    <div className="grid-col-12">
                        <div className="grid-row">
                            <NavBarContainer navBarClass="grid-col-12"/>
                        </div>
                    </div>
                    <div className="grid-col-12 margin-top-1">
                        <div className="grid-row padding-t-20">
                            <div className="grid-col-3">
                                <div className="margin-bottom-3">
                                    <img id="issuer-logo" alt={`logo ${issuerName}`} src={logoSrc} className="resize-img img_center_h" />
                                </div>
                            </div>
                            <div className="grid-col-9">
                                <h1>{issuerName}</h1>
                            </div>
                        </div>
                    </div>
                    <IssuerSidebar />
                    <FeaturePlanMainContent />
                </Layouts.Row>
            </Layouts>
        </LayoutContainer>
    );
        
};

export default IssuerFeaturePlanContainer;